import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { LOYALTY_CARD_PAGE_PATH } from "utils/constants/paths";

const LoyaltyCardPage = Loadable(React.lazy(() => import("./View")));

export const LoyaltyCardsRoute: IRouteItem = {
  path: LOYALTY_CARD_PAGE_PATH,
  element: React.createElement(LoyaltyCardPage),
  name: "Loyalty Card",
};
